const getSortByEventName = (name: string) => `sortby_${name.toLowerCase().replace(' ', '_')}`;

export default getSortByEventName;
